export const wait = (ms: number) => new Promise<void>((resolve) => setTimeout(resolve, ms));

export const randomBetween = (min: number, max: number) =>
  Math.floor(Math.random() * (max - min + 1)) + min;

export const randomFrom = <T,>(arr: T[]): T => arr[Math.floor(Math.random() * arr.length)];

export const newId = (): string => {
  if (typeof crypto !== 'undefined' && 'randomUUID' in crypto) {
    return crypto.randomUUID();
  }
  return `id-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
};
